import { Component, Input, forwardRef, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-form-timestamp',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="form-section">
      <label *ngIf="label" [attr.for]="id">{{ label }}</label>
      <div 
        [id]="id"
        class="timestamp-display"
        style="padding: 8px; background-color: #f5f5f5; border: 1px solid #ccc; border-radius: 4px; color: #333;"
      >{{ formattedTimestamp }}</div>
    </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormTimestampComponent),
      multi: true
    }
  ],
  styleUrls: ['total-component.scss']
})
export class FormTimestampComponent implements ControlValueAccessor, OnInit {
  @Input() label: string = '填寫時間'; // 標籤
  @Input() id: string = ''; // id 用於對應 label
  @Input() name: string = ''; // name 用於表單提交
  @Input() format: string = 'datetime'; // 格式: 'datetime', 'date', 'time'

  value: string = ''; // 綁定的值
  formattedTimestamp: string = '';
  private currentTimestamp: Date = new Date();

  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  ngOnInit(): void {
    this.updateTimestamp();
  }

  private updateTimestamp(): void {
    this.currentTimestamp = new Date();
    this.formatTimestamp();
    this.value = this.currentTimestamp.toISOString();
    this.onChange(this.value);
  }

  private formatTimestamp(): void {
    const now = this.currentTimestamp;
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hour = String(now.getHours()).padStart(2, '0');
    const minute = String(now.getMinutes()).padStart(2, '0');
    const second = String(now.getSeconds()).padStart(2, '0');

    switch (this.format) {
      case 'date':
        this.formattedTimestamp = `${year}/${month}/${day}`;
        break;
      case 'time':
        this.formattedTimestamp = `${hour}:${minute}:${second}`;
        break;
      case 'datetime':
      default:
        this.formattedTimestamp = `${year}/${month}/${day} ${hour}:${minute}:${second}`;
        break;
    }
  }

  // ControlValueAccessor 實作
  writeValue(value: any): void {
    if (value !== undefined) {
      this.value = value;
      if (value) {
        this.currentTimestamp = new Date(value);
        this.formatTimestamp();
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // 時間顯示元件本身就是唯讀的，不需要特別處理 disabled 狀態
  }
}